import { api_GET, api_POST, api_PUT } from "./_api.js";

const layoutDiarioOficial_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`LayoutDiarioOficial/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`LayoutDiarioOficial/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`LayoutDiarioOficial`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`LayoutDiarioOficial`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default layoutDiarioOficial_api;
